"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _genericValidation = require("../global/utils/genericValidation");

var _paymentHelpers = require("./paymentHelpers");

var _splititFunctions = require("./splititFunctions");

var _Loader = _interopRequireDefault(require("../global/components/Loader"));

var _loggers = require("../global/utils/loggers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SplititHostedForm = function SplititHostedForm(props) {
  var children = props.children,
      showForm = props.showForm,
      formType = props.formType,
      _props$useLoader = props.useLoader,
      useLoader = _props$useLoader === void 0 ? true : _props$useLoader,
      splititLoadingEndHandler = props.splititLoadingEndHandler,
      splititLoadingErrorHandler = props.splititLoadingErrorHandler;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      formIsReady = _useState2[0],
      setFormIsReady = _useState2[1];

  var _useState3 = (0, _react.useState)({}),
      _useState4 = _slicedToArray(_useState3, 2),
      splititData = _useState4[0],
      setSplititData = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showLoader = _useState6[0],
      setShowLoader = _useState6[1];

  var handleSplititLoaded = function handleSplititLoaded(data) {
    // @ts-ignore:
    if ((0, _genericValidation.isFunction)(splititLoadingEndHandler)) splititLoadingEndHandler(data);
    setFormIsReady(true);
  };
  /**
   * We show the loader via this useEffect because if we did the conditional check
   * in the return statement (conditional rendering) then this line:
   *    window.location.href = splititData?.CheckoutUrl;
   * would hide the loader before the user is redirected to splitit
   */


  (0, _react.useEffect)(function () {
    if (showForm && formType === _paymentHelpers.formTypes.splitit && useLoader) setShowLoader(true);
  }, [showForm, formType, useLoader]);
  (0, _react.useEffect)(function () {
    var getData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _splititFunctions.initSplitit)(props);

              case 2:
                res = _context.sent;

                if ((0, _genericValidation.isNonEmptyString)(res === null || res === void 0 ? void 0 : res.CheckoutUrl) ? // @ts-ignore
                (res === null || res === void 0 ? void 0 : res.CheckoutUrl) !== (splititData === null || splititData === void 0 ? void 0 : splititData.CheckoutUrl) : false) {
                  handleSplititLoaded(res); // @ts-ignore

                  setSplititData(res);
                } else if ((0, _genericValidation.isNonEmptyString)(res === null || res === void 0 ? void 0 : res.CheckoutUrl)) {
                  (0, _loggers.localLogger)('%cRetrieved data from session storage', 'color: palegoldenrod', {
                    savedData: res
                  });
                } else if (res instanceof Error) {
                  if ((0, _genericValidation.isFunction)(splititLoadingErrorHandler)) // @ts-ignore
                    splititLoadingErrorHandler(res);
                } else {
                  (0, _loggers.localLogger)('%cCould not initialize splitit, please check the props you passed to the SplititHostedForm component', 'color: tomato', {
                    propsPassed: res
                  });
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getData() {
        return _ref.apply(this, arguments);
      };
    }();

    if (showForm) getData();
  });
  (0, _react.useEffect)(function () {
    var _splititData$Checkout;

    if ( // @ts-ignore:
    (0, _genericValidation.isNonEmptyString)((_splititData$Checkout = splititData === null || splititData === void 0 ? void 0 : splititData.CheckoutUrl) !== null && _splititData$Checkout !== void 0 ? _splititData$Checkout : '') && formIsReady && showForm && formType === _paymentHelpers.formTypes.splitit) {
      var _window, _window$sessionStorag;

      (_window = window) === null || _window === void 0 ? void 0 : (_window$sessionStorag = _window.sessionStorage) === null || _window$sessionStorag === void 0 ? void 0 : _window$sessionStorag.removeItem(_splititFunctions.splititSessionStorageKey); // @ts-ignore:

      window.location.href = splititData === null || splititData === void 0 ? void 0 : splititData.CheckoutUrl;
    }
  }, [showForm, splititData, formIsReady, formType]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showLoader ? children ? children : /*#__PURE__*/_react.default.createElement(_Loader.default, null) : null);
};

var _default = SplititHostedForm;
exports.default = _default;